import React, { useEffect, useState } from 'react';
import { clients } from './api';

// =============================================================================
// ClientPicker (5.15.0) — the search half of LinkToClientModal, generic: a debounced
// clients.search (min 2 chars, 250 ms) and a result list; clicking a result calls
// onPick(client) with the /clients/search row. No writes of its own.
// LinkToClientModal is unchanged and keeps its own copy of this UI.
// =============================================================================

export default function ClientPicker({ onPick, darkMode, initialQuery = '', autoFocus = true, disabled = false, maxHeight = 260 }) {
  const subPanelBg = darkMode ? '#1a1a1a' : '#f5f5f5';
  const borderColor = darkMode ? '#333' : '#e5e5e5';
  const textPrimary = darkMode ? '#f0f0f0' : '#1a1a1a';
  const textSecondary = darkMode ? '#aaa' : '#666';
  const inputBg = darkMode ? '#1a1a1a' : '#fff';

  const [query, setQuery] = useState(initialQuery || '');
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    if (!query || query.length < 2) { setResults([]); return; }
    const timer = setTimeout(() => {
      setSearching(true);
      clients.search(query)
        .then((r) => setResults((r.data?.results) || []))
        .catch(() => setResults([]))
        .finally(() => setSearching(false));
    }, 250);
    return () => clearTimeout(timer);
  }, [query]);

  return (
    <div>
      <input
        autoFocus={autoFocus}
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Type a client name…"
        style={{
          width: '100%', padding: '10px 12px', fontSize: 14,
          background: inputBg, color: textPrimary,
          border: `1px solid ${borderColor}`, borderRadius: 5,
          boxSizing: 'border-box',
        }}
      />
      <div style={{ maxHeight, overflowY: 'auto', marginTop: 8 }}>
        {searching && (
          <div style={{ padding: 12, textAlign: 'center', color: textSecondary, fontSize: 12 }}>Searching…</div>
        )}
        {!searching && query.length >= 2 && results.length === 0 && (
          <div style={{ padding: 12, textAlign: 'center', color: textSecondary, fontSize: 12 }}>No matches found.</div>
        )}
        {results.map(r => (
          <div
            key={r.id}
            data-testid={`client-pick-${r.id}`}
            onClick={() => !disabled && onPick && onPick(r)}
            style={{
              padding: '10px 12px', borderRadius: 5, cursor: disabled ? 'wait' : 'pointer',
              background: subPanelBg, marginBottom: 6, color: textPrimary,
              border: `1px solid ${borderColor}`, fontSize: 13, opacity: disabled ? 0.5 : 1,
            }}
            onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.background = '#185FA5'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = subPanelBg; }}
          >
            <div style={{ fontWeight: 600 }}>{r.name}</div>
            {r.address_name && (
              <div style={{ fontSize: 11, color: textSecondary, marginTop: 2 }}>{r.address_name}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
